import { PortableText } from '@portabletext/react';
import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';

type TwoColumnsProps = {
  anchor?: string;
  title: string;
  description: string;
  text1:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  text2:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
};

const TwoTextColumns = ({
  anchor,
  title,
  description,
  text1,
  text2,
}: TwoColumnsProps) => {
  return (
    <section id={anchor} className="max-w-8xl mx-auto mt-8 scroll-mt-[150px]">
      <h3 className="font-bold text-lg pb-3">{title}</h3>
      <p className="pb-4">{description}</p>
      <div className="flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/2">
          <div className="[&>h4]:font-bold [&>h4]:text-red-800 [&>h4]:pb-4 [&>ul>li]:list-disc [&>ul>li]:mb-2 [&>ul>li]:ml-4">
            {text1 && <PortableText value={text1} />}
          </div>
        </div>
        <div className="w-full lg:w-1/2">
          <div className="[&>h4]:font-bold [&>h4]:text-green-800 [&>h4]:pb-4 [&>ul>li]:list-disc [&>ul>li]:mb-2 [&>ul>li]:ml-4">
            {text2 && <PortableText value={text2} />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TwoTextColumns;
